import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function deleteTag(tagId: string, auth: Authentication): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new DeleteTagFailure('Unauthorized', 'unauthorized');
  }

  try {
    await HttpClient.delete(`/tags/${tagId}`, {}, auth.token);
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Unknown error';
    throw new DeleteTagFailure(message);
  }
}

export class DeleteTagFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteTag;
